import React, { useState, useEffect } from 'react';
import { supabase } from '../supabaseClient';
import { usePageTitle } from '../hooks/usePageTitle';
import './Terms.css';

function Terms() {
  usePageTitle('Terms of Service');
  const [content, setContent] = useState('');

  useEffect(() => {
    const defaultTerms = `Last Updated: ${new Date().toLocaleDateString()}

Welcome to Biltzentech. By accessing or using our services, you agree to be bound by these Terms of Service.

**Acceptance of Terms**

By using our website and services, you acknowledge that you have read, understood, and agree to be bound by these Terms of Service and our Privacy Policy.

**Services**

Biltzentech provides AI development, software engineering, and technology consulting services. We reserve the right to modify, suspend, or discontinue any aspect of our services at any time.

**User Responsibilities**

You agree to:
- Provide accurate and complete information
- Maintain the confidentiality of your account credentials
- Use our services in compliance with all applicable laws
- Not engage in any activity that interferes with our services

**Intellectual Property**

All content, trademarks, and intellectual property on our website are owned by Biltzentech. You may not use, reproduce, or distribute our content without prior written permission.

**Limitation of Liability**

Biltzentech shall not be liable for any indirect, incidental, special, or consequential damages arising from your use of our services.

**Governing Law**

These Terms shall be governed by and construed in accordance with applicable laws, without regard to conflict of law provisions.

**Contact Information**

For questions about these Terms of Service, contact us at:
Email: contact@biltzentech.com
Phone: +91 9740736690`;
    supabase.from('site_content').select('content').eq('id', 'terms_of_service').single().then(({ data }) => {
      setContent(data?.content || defaultTerms);
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="terms">
      <section className="terms-hero">
        <div className="terms-container">
          <h1 className="terms-hero-title">Terms of Service</h1>
          <p className="terms-hero-subtitle">Please read these terms carefully</p>
        </div>
      </section>

      <section className="terms-main">
        <div className="terms-container">
          <div className="terms-content">
            {content.split('\n\n').map((paragraph, index) => {
              if (paragraph.startsWith('**') && paragraph.endsWith('**')) {
                return <h2 key={index}>{paragraph.replace(/\*\*/g, '')}</h2>;
              }
              return <p key={index}>{paragraph}</p>;
            })}
          </div>
        </div>
      </section>
    </div>
  );
}

export default Terms;
